import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "./layout/SideBar";
import Header from "./layout/Header";
import { jwtDecode } from "jwt-decode";
import { logout, setIsLoggedIn, setUser } from "./features/auth/authSlice";
import { useEffect } from "react";
import axiosInstance from "./instance";
import { cleanCurrent } from "./features/sms-request/smsRequestSlice";

export const ProtectedRoute = () => {
  const { isLoggedIn, token, user } = useSelector((state) => state.auth);
  const { menuData } = useSelector((state) => state.menu);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  const isTokenExpired = (accessToken) => {
    if (!accessToken) return true;

    const decodedToken = accessToken?.length && jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return decodedToken?.exp < currentTime;
  };

  async function clean() {
    await dispatch(cleanCurrent());
  }

  async function handleInit() {
    if (token?.length > 0) {
      const decoded = await jwtDecode(token);
      await dispatch(setUser(decoded));
    }
  }

  async function handleLogout() {
    await dispatch(logout());
    await localStorage.clear();
    await dispatch(setIsLoggedIn(false));
    await navigate("/login");
    await clean();
  }

  useEffect(() => {
    if (user?.changePassword === true || user?.changePassword === null) {
      navigate("/account-settings");
    }
  }, [user]);

  useEffect(() => {
    if (isTokenExpired(token) || !menuData || menuData?.length === 0) {
      handleLogout();
    }
  }, [token, pathname, menuData]);

  useEffect(() => {
    clean();
  }, [pathname]);

  useEffect(() => {
    handleInit();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="weiser-interior-shell">
      <div className="weiser-interior-ambient" />
      <div className="weiser-interior-orb weiser-interior-orb-top" />
      <div className="weiser-interior-orb weiser-interior-orb-bottom" />

      <div className="weiser-interior-layout">
        <SideBar />
        <div className="weiser-main-column">
          <Header embedded />
          <div className="weiser-interior-content">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
